/*************************************************************************
 *
 * グローバルメニューのオーバーレイメニュー
 *
 *************************************************************************/
$(function() {
  $("#menu_area #menu01 li[data-overlay]").each(function() {
    const content = $(this);
    const overlay = $(content.data("overlay"));

    /*
     * オーバーレイメニューを表示します。
     */
    function show() {
      $("#menu_area .menu-overlay").hide();
      overlay.slideDown();
      content.addClass("overlay-show");
    }

    /*
     * オーバーレイメニューを閉じます。
     */
    function close() {
	overlay.slideUp();
	content.removeClass("overlay-show");
    }
    
    /*
     * メニューの押下でオーバーレイメニューを表示します。
     */
    content.find("a:first-child").click(function(event) {
      event.preventDefault();
      show();
    });


    /*
     * 「x」ボタンの押下でオーバーレイメニューを閉じます。
     */
    overlay.find(".close").click(function(event) {
      event.preventDefault();
      close();
      return false;
    });
    
    /*
     * 背景部分の押下でオーバーレイメニューを閉じます。
     */
    $(document).click(function(event) {
      if (event.target != content.find("a:first-child").get(0)) {
	close();
      }
    });

    /*
     * スクロール位置によってオーバーレイメニューの位置を調整します。
     */
    (function() {
      function position() {
	if ($(document).scrollTop() >= 47) {
	  overlay.css({
	    position: "fixed",
	  });
	} else {
	  overlay.css({
	    position: "absolute",
	  });
	}
      }

      $(window).resize(position);
      $(window).scroll(position);
      position();
    })();
  });
});



// WEBPACK FOOTER //
// ./src/js/moc_header_overlay.js